<template>
  <div>
    <div v-if="readonly && files.length == 0" style="color: #cccccc">无内容</div>
    <van-uploader
      v-else
      v-model="files"
      accept=".jpg, .jpeg, .png"
      :multiple="item.fileMaxCount && item.fileMaxCount > 1"
      :max-count="item.fileMaxCount? item.fileMaxCount : 1"
      :max-size="(item.fileMaxSize?item.fileMaxSize:1) * 1024 * 1024"
      :after-read="afterRead"
      :readonly="readonly"
      :deletable="!readonly"
      :show-upload="!readonly"
      :preview-options="{ images: fullImagePreviewPathes }"
      @oversize="onOversize"
    >
      <template #preview-cover="{ name, status }">
        <div v-if="!readonly && status == 'done'" class="success-tip">上传成功</div>
        <div class="preview-cover">{{ name }}</div>
      </template>
    </van-uploader>
  </div>
</template>

<script>
import request from "@/utils/RequestWithVant";
import Compressor from "compressorjs";

export default {
  components: {},
  props: ["formId", "item", "readonly"],
  data() {
    return {
      files: [],
      uploadUrl: "/api/file/upload/form_data",
      fullImagePreviewPathes: [],
    };
  },
  watch: {
    files: {
      deep: true, //深度监听
      handler: function (files) {
        console.log("files changed", files);
        if (files && files.length > 0) {
          let arr = [];
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (file.status == "done") {
              arr.push({
                path: file.path,
                name: file.name,
                type: file.type,
                thumbnail: file.thumbnail,
              });
            }
          }
          if (arr.length > 0) {
            this.item.value = JSON.stringify(arr);
          } else {
            this.item.value = "";
          }

          // 生成预览图数组
          let fullPathes = [];
          for (let i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            fullPathes.push("/idata" + file.path);
          }
          this.fullImagePreviewPathes = fullPathes;
        }
      },
    },
  },
  created() {
    if (this.item.value) {
      let arr = JSON.parse(this.item.value);
      if (arr && arr instanceof Array) {
        let files = [];
        for (let i = 0; i < arr.length; i++) {
          let file = arr[i];
          files.push({
            url: "/idata" + (file.thumbnail ? file.thumbnail : file.path),
            path: file.path,
            name: file.name,
            type: file.type,
            thumbnail: file.thumbnail,
            status: "done",
          });
        }
        this.files = files;
      }
    }
  },
  methods: {
    onOversize(file) {
      console.log("onOversize", file);
      this.$notify({
        type: "warning",
        duration: 3000,
        message:
          "文件大小不能超过" +
          (this.item.fileMaxSize ? this.item.fileMaxSize : 1) +
          "M",
      });
    },
    afterRead(file) {
      if (file instanceof Array) {
        for (let i = 0; i < file.length; i++) {
          this.uploadFile(file[i]);
        }
      } else {
        this.uploadFile(file);
      }
    },
    uploadFile(file) {
      let _this = this;
      file.name = file.file.name;
      file.type = file.file.type;
      file.status = "uploading";
      file.message = "上传中...";

      if (file.type.startsWith("image")) {
        // 图片类型先上传缩略图

        new Compressor(file.file, {
          maxWidth: 720,
          maxHeight: 720,
          success(compressedFile) {
            _this.doUpload(compressedFile).then(
              function (res) {
                console.log("缩略图上传成功", res);
                file.thumbnail = res.data;
                _this.uploadOriginalFile(file);
              },
              function (res) {
                console.log("缩略图上传失败", res);
                file.status = "failed";
                file.message = "上传失败";
              }
            );
          },
          error(err) {
            console.error("图片压缩失败", err.message);
            file.status = "failed";
            file.message = "上传失败";
          },
        });
      } else {
        this.uploadOriginalFile(file);
      }
    },
    uploadOriginalFile(file) {
      this.doUpload(file.file).then(
        function (res) {
          console.log("文件上传成功", res);
          file.status = "done";
          file.message = "上传成功";
          file.url = "/idata" + res.data;
          file.path = res.data;
        },
        function (res) {
          console.log("文件上传失败", res);
          file.status = "failed";
          file.message = "上传失败";
        }
      );
    },
    doUpload(originalFile) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("file", originalFile, originalFile.name);
        formData.append("formId", this.formId);
        request
          .post(this.uploadUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((res) => {
            reject(res);
          });
      });
    },
  },
};
</script>
<style scoped>
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  line-height: 1em;
  max-height: 60px;
}

.success-tip {
  font-size: 10px;
  line-height: 16px;
  padding-left: 3px;
  background: rgba(255, 255, 255, 0.5);
}

::v-deep .van-uploader__file-name {
  display: none;
}
</style>